import { Action, createReducer, on } from '@ngrx/store';
import { stateHelperFunctions } from '../stateHelperFunctions';
import {
  addEvaluationsFailureAction,
  addEvaluationsSuccessAction,
  clearStudentEvaluationAction, getEvaluationsAction,
  getEvaluationsFailureAction,
  getEvaluationsSuccessAction,
  setSetStudentEvaluationStepNumberAction,
  updateEvaluationsFailureAction,
  updateEvaluationsSuccessAction
} from './student-evaluation.actions';
import { IStudentEvaluationState } from './student-evaluation.state';

export const initialStudentEvaluationState: IStudentEvaluationState = {
  evaluations: [],
  isLoadingEvaluations: false,
  studentEvaluationStepNumber: 0,
  error: undefined
};

const studentEvaluationReducer = createReducer(
  initialStudentEvaluationState,

  on(setSetStudentEvaluationStepNumberAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      studentEvaluationStepNumber: action.stepNumber
    })
  ),

  on(clearStudentEvaluationAction,
      (state): IStudentEvaluationState => ({
      ...initialStudentEvaluationState
      })
  ),

  on(getEvaluationsAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      isLoadingEvaluations: true
    })
  ),

  on(getEvaluationsSuccessAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      evaluations: action.evaluations,
      isLoadingEvaluations: false
    })
  ),

  on(addEvaluationsFailureAction,
    updateEvaluationsFailureAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      error: action.error
    })
  ),

  on(getEvaluationsFailureAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      isLoadingEvaluations: false,
      error: action.error
    })
  ),

  on(addEvaluationsSuccessAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      evaluations: state.evaluations.concat(action.evaluations)
    })
  ),

  on(updateEvaluationsSuccessAction,
    (state, action): IStudentEvaluationState => ({
      ...state,
      evaluations: stateHelperFunctions.replaceItemInArray(state.evaluations, action.evaluation)
    })
  ),
);

export function studentEvaluationReducers(state: IStudentEvaluationState, action: Action) {
  return studentEvaluationReducer(state, action);
}
